var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ActionService, ActionState, PendingEvent } from '../../Application';
import { ExceptionHandler } from '../../System';
import { ServerAction } from '../Server';
var ActionServiceV5 = (function (_super) {
    __extends(ActionServiceV5, _super);
    function ActionServiceV5() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionServiceV5.prototype.send = function (action, includeDirty) {
        var request = this.requestBuilder.create(action);
        if (action.requestConfig.includeDirty) {
            request.Changed = this.changeBuffer.getChanges();
        }
        if (request.Actions) {
            request.Actions = request.Actions.concat(this.buildCommandGenerators().map(function (c) {
                return new ServerAction(c.receiverId, c.command, c.data);
            }));
        }
        if (action.highPriority) {
            this.pendingEvents.unshift(new PendingEvent(action, request));
        }
        else {
            this.pendingEvents.push(new PendingEvent(action, request));
        }
        this.sendActions();
    };
    ActionServiceV5.prototype.sendActions = function () {
        var _this = this;
        if (this.state === ActionState.Idle) {
            this.state = ActionState.Sending;
            var event_1 = this.pendingEvents.shift();
            var data = JSON.stringify(event_1.request);
            this.http.post(this.urlResolver.resolveUrl(event_1.action), data, function (response) { _this.handleResponse(event_1.action, response); }, event_1.action.requestConfig, event_1.action.serverEvent);
        }
    };
    ActionServiceV5.prototype.sendImmediateAction = function (action, includeDirty) {
        var _this = this;
        var request = this.requestBuilder.create(action);
        if (action.requestConfig.includeDirty) {
            request.Changed = this.changeBuffer.getChanges();
        }
        if (request.Actions) {
            request.Actions = request.Actions.concat(this.buildCommandGenerators().map(function (c) {
                return new ServerAction(c.receiverId, c.command, c.data);
            }));
        }
        var event = new PendingEvent(action, request);
        var data = JSON.stringify(event.request);
        this.http.post(this.urlResolver.resolveUrl(event.action), data, function (response) { _this.handleResponse(event.action, response); }, event.action.requestConfig, event.action.serverEvent);
    };
    __decorate([
        ExceptionHandler('onException'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ActionServiceV5.prototype, "sendActions", null);
    __decorate([
        ExceptionHandler('onException'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Boolean]),
        __metadata("design:returntype", void 0)
    ], ActionServiceV5.prototype, "sendImmediateAction", null);
    return ActionServiceV5;
}(ActionService));
export { ActionServiceV5 };
